import { render, staticRenderFns } from "./ModelsContainer.vue?vue&type=template&id=b0ba3884&scoped=true&"
import script from "./ModelsContainer.vue?vue&type=script&lang=js&"
export * from "./ModelsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModelsContainer.vue?vue&type=style&index=0&id=b0ba3884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ba3884",
  null
  
)

export default component.exports